"use client";
import Chart from "../Chart";

export const ValueOf1PercChart = () => {
  return (
    <Chart
      xLabel="Interest rate"
      yLabel="Doubling period (years)"
      tooltipLabel="years"
      xLabelFormat=".0%"
      xHoverFormat=".2%"
      data={[
        {
          hoverTxt: (x: number, y: number) =>
            `${y} years, for ${x} interest rate`,
          x: Array.from({ length: 40 }, (v, k) => (0.5 + k * 0.5) / 100),
          y: Array.from({ length: 40 }, (v, k) => (0.5 + k * 0.5) / 100).map(
            (x) => Math.log(2) / Math.log(1 + x),
          ),
        },
      ]}
    />
  );
};
